var standardSizesMixin = {
	methods: {
		setSheetStandardSize: function (event) {
			const value = event.target.value;
			const dimensions = value.split('x');
			const vm = this;

			const height = dimensions[0];
			const width = dimensions[1];

			if (value != 0) {
				// standard sizes always mm
				vm.product.dimensions.unit = 'mm';

				vm.product.dimensions.height = height;
				vm.product.dimensions.width = width;
				vm.displayDimensions.width = width;
				vm.displayDimensions.height = height;
			}

			vm.$refs['height'].classList.remove('is-invalid');
			vm.$refs['width'].classList.remove('is-invalid');

			vm.$refs['height'].parentElement.classList.remove('is-invalid');
			vm.$refs['width'].parentElement.classList.remove('is-invalid');

			vm.updateProductPrice();
		},
		setRodDiscStandardSize: function (event) {
			const value = event.target.value;
			const vm = this;

			if (value != 0) {
				// standard sizes always mm
				vm.product.dimensions.unit = 'mm';

				if (document.querySelector('input#diameter')) {
					vm.product.dimensions.diameter = value;
					vm.displayDimensions.diameter = value;

					document.querySelector('input#diameter').classList.remove('is-invalid');
					document.querySelector('input#diameter').parentElement.classList.remove('is-invalid');
				} else {
					vm.product.dimensions.length = value;
					vm.displayDimensions.length = value;

					document.querySelector('input#length').classList.remove('is-invalid');
					document.querySelector('input#length').parentElement.classList.remove('is-invalid');
				}
			}

			vm.updateProductPrice();
		},
	},
};
